<template>
  <div v-loading="$wait.waiting(_uid)" class="people-detail card text-left">
    <div class="card-content">
      <el-tabs :value="activeTab" @tab-click="selectTab">
        <el-tab-pane v-if="isActive" label="Profile" name="profile">
          <div v-if="matchTab('profile')">
            <Profile :user="user" />
          </div>
        </el-tab-pane>

        <el-tab-pane
          v-if="isTrainee && isActive"
          label="Program"
          name="program"
        >
          <div v-if="matchTab('program')">
            <UserBanner :user="user" />
            <TrainingProgram />
          </div>
        </el-tab-pane>

        <el-tab-pane
          v-if="isTrainee && isActive"
          label="Schedule"
          name="schedule"
        >
          <div v-if="matchTab('schedule')">
            <UserBanner :user="user" />
            <TrainingSchedule />
          </div>
        </el-tab-pane>

        <el-tab-pane v-if="isTrainee" label="Training Record" name="record">
          <div v-if="matchTab('record')">
            <UserBanner :user="user" />
            <TrainingRecord />
          </div>
        </el-tab-pane>

        <el-tab-pane v-if="isActive" label="Events / Documents" name="events">
          <div v-if="matchTab('events')">
            <UserBanner :user="user" />
            <Events />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Loading, Tabs, TabPane } from "element-ui";
import Profile from "@components/Dashboard/Views/Pages/Company/Users/Components/Profile";
import TrainingProgram from "@components/Dashboard/Views/Pages/Company/Users/Components/Program";
import TrainingSchedule from "@components/Dashboard/Views/Pages/Company/Users/Components/Schedule";
import TrainingRecord from "@components/Dashboard/Views/Pages/Company/Users/Components/Record";
import Events from "@components/Dashboard/Views/Pages/Company/Users/Events/Event.vue";
import UserBanner from "@components/UIComponents/Banners/UserBanner.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";

Vue.use(Loading.directive);
Vue.use(Tabs);
Vue.use(TabPane);

export default {
  components: {
    Profile,
    UserBanner,
    TrainingProgram,
    TrainingSchedule,
    TrainingRecord,
    Events,
  },
  data() {
    return { activeTab: "profile" };
  },
  computed: {
    ...mapGetters("companyUserStore", ["users", "user"]),
    ...mapGetters("loadingStore", { isLoading: "loading" }),
    routeParams() {
      return this.$route.params;
    },
    routeQuery() {
      return this.$route.query;
    },
    isTrainee() {
      const userAcl = this.user.acl.roles;
      return userAcl.some((acl) => acl.name === "Trainee");
    },
    isActive() {
      return this.user.isActive;
    },
  },
  async mounted() {
    try {
      this.$wait.start(this._uid);
      const userId = this.routeParams.id;
      await this.getUser(userId);
      this.selectTab({ paneName: this.routeQuery.tab });
    } catch (error) {
      this.addNewError(error);
    } finally {
      this.$wait.end(this._uid);
    }
  },
  methods: {
    ...mapActions("errorStore", ["addNewError"]),
    ...mapMutations("loadingStore", ["setLoading"]),
    ...mapActions("companyUserStore", ["getUser", "deleteUser"]),
    selectTab({ paneName }) {
      if (!paneName) {
        return (this.activeTab = "profile");
      }
      this.activeTab = paneName;
    },
    matchTab(pane) {
      return this.activeTab === pane;
    },
  },
};
</script>

<style lang="scss">
.people-detail {
  ul.contact li {
    line-height: calc(100% + 4px);
  }
  .btn-cancel {
    margin: 0 12px;
  }
  @media (max-width: 1024px) {
    .wrapper-button .btn {
      width: 100%;
    }
    .btn-cancel {
      margin: 12px 0;
    }
  }
}
</style>
